export const apiPrefix =
  !process.env.REACT_APP_DEPLOY_ENV ||
  process.env.REACT_APP_DEPLOY_ENV === 'local'
    ? 'http://localhost:5000'
    : process.env.REACT_APP_API_URL;
